import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { GridTemplateListItem } from '~/types/forms';

import { useStyles } from '../../useStyles';

type Props = {
  selectedTemplateId: string;
  formTemplates: GridTemplateListItem[];
  onFormTemplateChange: (id: string) => void;
};

export const FormTemplateSelections = ({
  formTemplates,
  selectedTemplateId,
  onFormTemplateChange,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useStyles();

  return (
    <Autocomplete
      sx={{
        ...sxStyles.dropdown,
      }}
      placeholder={' '}
      options={formTemplates}
      getOptionLabel={(c) => c.title}
      isOptionEqualToValue={(o, v) => o._id === v._id}
      value={formTemplates.find((c) => c._id === selectedTemplateId) ?? null}
      onChange={(_, value) => {
        onFormTemplateChange(value?._id || '');
      }}
      renderInput={(params) => (
        <TextField {...params} label={t('laSelectTemplate')} />
      )}
    />
  );
};
